import axios from "axios";
import * as API_LINKS from '../../../configurations/links.jsx'
import {toast} from 'react-toastify';
import cookie from 'react-cookies';

export const FETCH_BAGIAN_SATUAN_LIST = 'FETCH_BAGIAN_SATUAN_LIST'
export const RECEIVE_BAGIAN_SATUAN_LIST = 'RECEIVE_BAGIAN_SATUAN_LIST'
export const FAILED_BAGIAN_SATUAN_LIST = 'FAILED_BAGIAN_SATUAN_LIST'


export function fetchBagianSatuanList(_data){
    return (dispatch, getState) => {
        dispatch({type: FETCH_BAGIAN_SATUAN_LIST});
        axios({
            method: 'post',
            url: API_LINKS.DIVISION_BAGIAN_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
             if(response.status === 200) {
                if(response.data.status === "success") {
                    dispatch( {
                        type: RECEIVE_BAGIAN_SATUAN_LIST,
                        payload: response.data.result
                    })
                   
                } else {
                    dispatch({
                        type: FAILED_BAGIAN_SATUAN_LIST
                    })
                    return toast.error(response.data.message);
                }
            } else {
                dispatch({
                    type: FAILED_BAGIAN_SATUAN_LIST
                })
                return toast.error(response.data.message);
            }
        })
        .catch(function(error){
            if (error.response){
                dispatch({
                    type: FAILED_BAGIAN_SATUAN_LIST
                })
                return toast.error(error.response.data.message);;
            }
        }
        )
        }
    }



// WEBPACK FOOTER //
// ./src/redux/actions/satuan/aSatuan-BagianSatuanList.jsx